(ns net.kestec.mhda-pilgrimage.admin.log-list
  (:require
    ["@mui/material/Paper" :default Paper]
    ["@mui/material/Typography" :default Typography]
    [day8.re-frame.http-fx]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]

    ))


(defn main []
  [base-page
   [:> Paper {:sx {:padding "7px"}}
    [:br]
    [:> Typography {:variant "h2"} "Log Liste"]]])

